import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { URL_SERVICES } from '../../config/config';
import { UserService } from '../user/user.service';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { Observable } from 'rxjs/Observable';

import * as _swal from 'sweetalert';
import { SweetAlert } from 'sweetalert/typings/core';
const swal: SweetAlert = _swal as any;

@Injectable()
export class MailService {

  constructor( public http: HttpClient, public _userService: UserService ) { }

  mailParaUsuario( tipo: string, congreso: string, nombre: string, apellido: string, to: string, lang: string, sociedadOrganizadora: string, titulo ?: string, tipoTrabajo ?: string, contactoAutor ?: string ) {
    let url = URL_SERVICES + '/mail/' + tipo;

    let object: any = {
      congreso: congreso,
      nombre: nombre,
      apellido: apellido,
      to: to,
      lang: lang,
      sociedadOrganizadora: sociedadOrganizadora,
      titulo: titulo,
      tipoTrabajo: tipoTrabajo,
      contactoAutor: contactoAutor
    };

    return this.http.post(url, object)
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this._userService.logout();
      }
      return Observable.throw(err);
    });
  }

  mailPagoRecibidoAdmin(congreso: string, nombre: string, apellido: string, to: string, sociedadOrganizadora: string, email: string, sociedad: string, razonSocial: string, direccion: string, cuil: string, condicionIva: string, urlComprobante: string, monto: number, tipoPago: string, paypalIdPago?: string) {
    let url = URL_SERVICES + '/mail/pagorecibido';

    let object: any = {
      congreso: congreso,
      nombre: nombre,
      apellido: apellido,
      to: to,
      sociedadOrganizadora: sociedadOrganizadora,
      email: email,
      sociedad: sociedad,
      razonSocial: razonSocial,
      direccion: direccion,
      cuil: cuil,
      condicionIva: condicionIva,
      urlComprobante: urlComprobante,
      monto: monto,
      tipoPago: tipoPago,
      paypalIdPago: paypalIdPago
    };

    return this.http.post(url, object)
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this._userService.logout();
      }
      return Observable.throw(err);
    });
  }

  mailTrabajoRecibidoAdmin(tipoMail: string, congreso: string, nombre: string, apellido: string, to: string, sociedadOrganizadora: string, email: string, sociedad: string, titulo: string, categoria: string, emailContacto: string, tipo?: string) {
    let url = URL_SERVICES + '/mail/' + tipoMail;

    let object: any = {
      congreso: congreso,
      nombre: nombre,
      apellido: apellido,
      to: to,
      sociedadOrganizadora: sociedadOrganizadora,
      email: email,
      sociedad: sociedad,
      titulo: titulo,
      categoria: categoria,
      emailContacto: emailContacto,
      tipo: tipo
    };

    return this.http.post(url, object)
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this._userService.logout();
      }
      return Observable.throw(err);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/mail/mail.service.ts